export type ListKind = "list" | "template" | "dish";
export type ItemStatus = "needed" | "done" | "missing";
export interface ListItem {
  id: string;
  name: string;
  amount: number | null;
  unit: string;
  note: string;
  group: string;
  status: ItemStatus;
  sourceDish: string;
}
export interface ListDocument {
  id: string;
  name: string;
  kind: ListKind;
  items: ListItem[];
  history: ListItem[];
  completed: "strike" | "bottom" | "hide";
  grouped: boolean;
  createdAt?: string;
  archivedAt?: string;
  updatedAt: string;
}
export interface ListsState { version: 1; documents: ListDocument[] }
export const emptyLists = (): ListsState => ({ version: 1, documents: [] });
export const listItemName = (name: string) => name.trim().replace(/\p{L}/u, letter => letter.toLocaleUpperCase("ru-RU"));
export function newList(name: string, kind: ListKind = "list"): ListDocument {
  const createdAt = new Date().toISOString();
  return { createdAt, id: crypto.randomUUID(), name: listItemName(name), kind, items: [], history: [], completed: "strike", grouped: false, updatedAt: new Date().toISOString() };
}
export function newItem(name: string): ListItem {
  return { id: crypto.randomUUID(), name: listItemName(name), amount: null, unit: "", note: "", group: "", status: "needed", sourceDish: "" };
}
export const itemQuantity = (item: ListItem) => [item.amount === null ? "" : item.amount.toLocaleString("ru-RU"), item.unit].filter(Boolean).join(" ");

export function automaticListName(documents: ListDocument[], date = new Date()): string {
  const base = new Intl.DateTimeFormat("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric" }).format(date);
  const names = new Set(documents.map(doc => doc.name));
  let name = base, number = 2;
  while (names.has(name)) name = `${base} (${number++})`;
  return name;
}

export function listCreationLabel(doc: ListDocument): string {
  if (!doc.createdAt) return "Дата создания не сохранена";
  const date = new Date(doc.createdAt);
  return Number.isFinite(date.getTime()) ? new Intl.DateTimeFormat("ru-RU", { day: "numeric", month: "long", year: "numeric" }).format(date) : "Дата создания не сохранена";
}
